import { createFileRoute } from '@tanstack/react-router'
import { SettingsPrivacyPage } from "@/pages/SettingsPrivacyPage";


export const Route = createFileRoute('/_app/settings/privacy')({
  component: SettingsPrivacyPage,
})
